export class TimeUtils {
  public static waitForTimeAsync(timeInMilliseconds: number) {
    return new Promise(resolve => {
      setTimeout(resolve, timeInMilliseconds);
    });
  }
}